import gql from 'graphql-tag';

import { WebGalleryHierarchyItemFields } from '../../graphql/fragments/account';
import { AccountPhotoAttributionPage } from '../../../../graphql/fragments/account';

export const accountProfile = gql`
  query accountProfile($username: String!) {
    accountProfile(username: $username) {
      id
      username
      name
      organization_name
      roles
    }
  }
`;
export const accountProfileById = gql`
  query accountProfile($id: RecordID!) {
    accountProfile(id: $id) {
      id
      username
      name
      organization_name
      site_url
      logo_image {
        id
        url
      }
      photo_attribution_page {
        ...AccountPhotoAttributionPage
      }
    }
  }
  ${AccountPhotoAttributionPage}
`;

export const proAccountProfile = gql`
  query proAccountProfile(
    $username: String!
    $limit: Int = 30
    $offset: Int = 0
    $futureLimit: Int = 6
    $futureOffset: Int = 0
    $sort: AccountProfileHierarchyItemsSortInput
    $with_join_code_only: Boolean = false
    $web_galleries_only: Boolean = true
  ) {
    accountProfile(username: $username) {
      id
      username
      name
      organization_name
      site_url
      logo_image {
        id
        url
      }
      avatar_photo {
        id
        thumbnail_urls {
          size_code
          url
        }
      }
      hero_image {
        id
        url
      }
      pro_directory {
        is_enabled
        description
      }
      future_hierarchy_items: hierarchy_items(
        date_filters: [PRESENT, FUTURE]
        slice: { limit: $futureLimit, offset: $futureOffset }
        sort: $sort
        with_join_code_only: $with_join_code_only
        web_galleries_only: $web_galleries_only
      ) {
        total
        records {
          ...HierarchyItemFields
        }
      }
      past_hierarchy_items: hierarchy_items(
        date_filters: [PAST, UNSPECIFIED]
        slice: { limit: $limit, offset: $offset }
        sort: $sort
        with_join_code_only: $with_join_code_only
        web_galleries_only: $web_galleries_only
      ) {
        total
        records {
          ...HierarchyItemFields
        }
      }
      hierarchy_items(
        slice: { limit: 1 }
        sort: $sort
        with_join_code_only: $with_join_code_only
        web_galleries_only: $web_galleries_only
      ) {
        total
        records {
          ...HierarchyItemFields
        }
      }
      photo_attribution_page {
        description
        contact_phone
        email_address
        instagram_url
      }
      roles
    }
  }
  ${WebGalleryHierarchyItemFields}
`;

export const shutterbugAccountProfile = gql`
  query shutterbugAccountProfile(
    $id: RecordID
    $username: String
    $limit: Int = 30
    $offset: Int = 0
    $sort: AccountProfileHierarchyItemsSortInput
    $with_join_code_only: Boolean = false
    $web_galleries_only: Boolean = true
  ) {
    accountProfile(id: $id, username: $username) {
      id
      username
      name
      organization_name
      logo_image {
        id
        url
      }
      avatar_photo {
        id
        thumbnail_urls {
          size_code
          url
        }
      }
      hero_image {
        id
        url
      }
      hierarchy_items(
        slice: { limit: $limit, offset: $offset }
        sort: $sort
        with_join_code_only: $with_join_code_only
        web_galleries_only: $web_galleries_only
      ) {
        total
        records {
          ...HierarchyItemFields
        }
      }
      photo_attribution_page {
        description
        contact_phone
        email_address
        instagram_url
      }
      roles
    }
  }
  ${WebGalleryHierarchyItemFields}
`;
